module.exports = "<ul class=\"ubg-tab-dialog-tabs\" [ngClass]=\"getTabsClass()\">\n  <ng-content></ng-content>\n</ul>"